export enum IndexType {
    Any = -200,
    RipeIndex = 0,
    MeritocracyRecords = 1,
    ClassicalMusic = 2,
    // Uprising = 3,
    // PopFavs = 4,
}